module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/taranto.1e11296a28d4b9a292eaff953bef1e93.jpg";